import {
  Redirect,
  Route,
  RouteComponentProps,
  useLocation
} from 'react-router-dom';
import AuthLayout from '../layout/AuthLayout/authLayout';
import EmailAddress from '../views/EmailAddress/EmailAddress';
import { FirstLogin } from '../views/FirstLogin/FirstLogin';
import ForgottenPassword from '../views/ForgottenPassword/ForgottenPassword';
import ForgottenPasswordNew from '../views/ForgottenPassword/Password';
import Login from '../views/Login/Login';
import Password from '../views/Password/Password';
import ProfileDetails from '../views/ProfileDetails/ProfileDetails';
import Referral from '../views/Referral/Referral';
import SecurityCode from '../views/SecurityCode/SecurityCode';
import TermsConditions from '../views/TermsConditions/TermsConditions';
import {
  DASHBOARD,
  FIRST_LOGIN,
  LOGIN,
  LOGIN_EARNBET,
  LOGIN_TRAVELUTION,
  PASSWORD,
  PROFILE_DETAILS,
  REFERRAL,
  TERMS_AND_CONDITIONS
} from './routes';

import { Finup } from '../views/Finup/Finup';
import { FinupTest } from '../views/Finup/FinupTest';
import { useAppSelector } from '../app/hooks';
import PageError from '../views/PageError/PageError';
import { Simplicity } from '../views/Simplicity/Simplicity';

import LoginEarnBet from '../views/Login/LoginEarnBet';

export const AuthRoutes = (props: RouteComponentProps) => {
  const { isCanadaRestrictedUser } = useAppSelector(
    (state) => state.auth.userInfo
  );
  const pathname = useLocation().pathname;

  const isCanadaRestrictedPath =
    isCanadaRestrictedUser &&
    (pathname === '/finup' || pathname === '/simplicity');

  return (
    <AuthLayout {...props}>
      <Route exact path={LOGIN} render={(props) => <Login {...props} />} />

      <Route
        exact
        path={LOGIN_EARNBET}
        render={(props) => <LoginEarnBet {...props} />}
      />

      {isCanadaRestrictedPath && <Redirect to={DASHBOARD} />}

      <Route
        exact
        path={REFERRAL}
        render={(props) => <Referral {...props} />}
      />

      <Route
        exact
        path={TERMS_AND_CONDITIONS}
        render={(props) => <TermsConditions {...props} />}
      />

      <Route
        exact
        path='/email-address/:id?/:childPosition?'
        render={(props) => <EmailAddress {...props} />}
      />

      <Route
        exact
        path={PASSWORD}
        render={(props) => <Password {...props} />}
      />

      <Route
        exact
        path={PROFILE_DETAILS}
        render={(props) => <ProfileDetails {...props} />}
      />

      <Route
        exact
        path={FIRST_LOGIN}
        render={(props) => <FirstLogin {...props} />}
      />

      <Route
        exact
        path='/ambassador/:referer?/:id?'
        render={(props) => <Login {...props} />}
      />
      <Route
        exact
        path='/ambassador/:referralCode'
        render={(props) => <Login {...props} />}
      />

      <Route
        path='/security-code'
        render={(props) => <SecurityCode {...props} />}
      />

      <Route
        exact
        path='/forgotten-password'
        render={() => <ForgottenPassword />}
      />

      <Route
        exact
        path='/forgotten-password-new'
        render={(props) => <ForgottenPasswordNew {...props} />}
      />

      {/* <Route exact path='/earnbet' render={(props) => <EarnBet />} /> */}

      {!isCanadaRestrictedUser && (
        <>
          <Route exact path='/finup' render={(props) => <Finup />} />
          <Route exact path='/finup-test' render={(props) => <FinupTest />} />
          <Route exact path='/simplicity' render={(props) => <Simplicity />} />
        </>
      )}
    </AuthLayout>
  );
};
